document.addEventListener('DOMContentLoaded', function() {
  let mainTitleButton = document.querySelector('[js-main-title]');
  let needHelpDrawer = document.querySelector('[js-need-help-drawer]');
  let helpDrawerClose = document.querySelector('[js-help-drawer-close]');
  let headerSection = document.querySelector('body #headerSection');
  let body = document.body;

  mainTitleButton.addEventListener('click', function(event) {
    event.stopPropagation();
    needHelpDrawer.classList.add('active');
    body.classList.add('overflow-hidden');
  });

  helpDrawerClose.addEventListener('click', function(event) {
    event.stopPropagation();
    needHelpDrawer.classList.remove('active');
    body.classList.remove('overflow-hidden');
  });

  // Optional: Close the drawer if clicked outside of it
  document.addEventListener('click', function(event) {
    if (!needHelpDrawer.contains(event.target) && !mainTitleButton.contains(event.target)) {
      needHelpDrawer.classList.remove('active');
      body.classList.remove('overflow-hidden');
    }
  });
});
